$(() => {

  // search tips
  let $searchTips = $('#searchBarTips').find('.search-tip'),
        stLength = $searchTips.length,
        current = 0,
        timeout = 5000;

  function rotateTips() {
      $searchTips.eq(current++).fadeOut(500, function(){
          if(current === stLength){
              current = 0;
          }
          $searchTips.eq(current).fadeIn(500);
      });
      setTimeout(rotateTips, timeout);
  }
  $searchTips.slice(1).hide();
  setTimeout(rotateTips, timeout);

  // fielded search
  const $fieldedSearch = $("#search_field_dropdown").find("a");
  const $searchField = $("#search_field");
  const $selected = $("#search-fields").find("span.selected");
  $fieldedSearch.on('click', function(e){
    e.preventDefault();
    let $this = $(this),
        text = $this.text(),
        searches = $this.data("search-field"),
        pretty = $this.data("pretty");
    $searchField.val(searches);
    $selected.text(pretty);
  });

});
